import React, { useState, useEffect } from 'react';
import { Facebook, GotToTopIcon, Linkdin, LogoIcon, Twitter, Instagram } from '../svg';
import { useNavigate, useLocation } from 'react-router-dom';
import KingsterLogo from '../logo.png'

const FooterComponent = () => {
  const [activePage, setActivePage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    if (path.includes('/courses')) {
      setActivePage('courses');
    } else if (path === '/') {
      setActivePage('home');
    } else if (path.includes('/about')) {
      setActivePage('about');
    } else if (path.includes('/blog')) {
      setActivePage('blogs');
    } else if (path.includes('/contact')) {
      setActivePage('contact');
    } else if (path.includes('/affiliate')) {
      setActivePage('affiliate');
    } else {
      setActivePage('');
    }
  }, [location]);

  const handleNavigation = (route, isExternal = false) => {
    if (isExternal) {
      window.open(route, '_blank');
    } else {
      if (route.includes('/courses')) {
        setActivePage('courses');
      } else if (route === '/') {
        setActivePage('home');
      } else if (route.includes('/about')) {
        setActivePage('about');
      } else if (route.includes('/blog')) {
        setActivePage('blogs');
      } else if (route.includes('/contact')) {
        setActivePage('contact');
      } else if (route.includes('/affiliate')) {
        setActivePage('affiliate');
      }
      navigate(route);
    }
  };

  const handleService1Click = () => {
    handleNavigation('https://kingster.edu.in/industry/', true);
  };

  const handleService2Click = () => {
    handleNavigation('https://kingster.edu.in/ancillary/', true);
  };

  const handleService3Click = () => {
    handleNavigation('https://kingster.edu.in/ecommerce/', true);
  };

  const handleLogoClick = () => {
    window.open('https://kingster.edu.in', '_blank');
  };

  // Common nav item classes
  const navItemBaseClasses = "inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[41px] px-4 py-2.5 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8]";
  const navItemActiveClasses = "bg-[#1D83F8] text-white border-[#DDE7EE]";

  return (
    <div className="bg-white mx-5 mt-5 mb-0">
      <div className="flex justify-between items-center bg-white px-10 py-5 w-full border-t border-[#EEF3F6] md:border-t-0 md:flex-row flex-col gap-5">
        {/* Logo - Centered for mobile, left-aligned for desktop */}
        <h2
          className="font-[Figtree] text-2xl font-black leading-[36px] text-left text-[#1D83F8] cursor-pointer w-full flex justify-center md:justify-start md:w-auto"
          onClick={handleLogoClick}
        >
          <img
            src={KingsterLogo}
            alt="Kingster Logo"
            className="h-16 w-auto"
          />
        </h2>

        {/* Desktop Navigation */}
        <div className="hidden md:flex flex-col items-center">
          <div className="bg-white border border-[#EEF3F6] rounded-full p-3 w-[630px]">
            {/* Top row */}
            <nav className="flex items-center justify-center gap-2">
              <button
                onClick={() => handleNavigation("https://kingster.edu.in/", true)}
                className={`${navItemBaseClasses} ${activePage === "home" ? navItemActiveClasses : ""}`}
              >
                Home
              </button>

              <button
                onClick={() => handleNavigation("https://kingster.edu.in/about-us/", true)}
                className={`${navItemBaseClasses} ${activePage === "about" ? navItemActiveClasses : ""}`}
              >
                About us
              </button>

              <button
                onClick={() => handleNavigation("/courses/Courses")}
                className={`${navItemBaseClasses} ${activePage === "courses" ? navItemActiveClasses : ""}`}
              >
                Courses
              </button>

              <button
                onClick={() => handleNavigation("/webinar/webinar", true)}
                className={`${navItemBaseClasses} ${activePage === "webinar" ? navItemActiveClasses : ""}`}
              >
                Webinar
              </button>

              <button
                onClick={() => handleNavigation("https://kingster.edu.in/blog/", true)}
                className={`${navItemBaseClasses} ${activePage === "blogs" ? navItemActiveClasses : ""}`}
              >
                Blogs
              </button>

              <button
                onClick={() => handleNavigation("https://kingster.edu.in/contact-us/", true)}
                className={`${navItemBaseClasses} ${activePage === "contact" ? navItemActiveClasses : ""}`}
              >
                Contact
              </button>

              <button
                onClick={() => handleNavigation("/affiliate/affiliate", false)}
                className={`${navItemBaseClasses} ${activePage === "affiliate" ? navItemActiveClasses : ""}`}
              >
                Affiliate
              </button>
            </nav>

            {/* Bottom row */}
            <nav className="flex items-center justify-center gap-2 mt-2">
              <button
                onClick={handleService1Click}
                className={navItemBaseClasses}
              >
                Industries We Serve
              </button>

              <button
                onClick={handleService2Click}
                className={navItemBaseClasses}
              >
                Ancillary Service
              </button>

              <button
                onClick={handleService3Click}
                className={navItemBaseClasses}
              >
                Ecommerce 2.0
              </button>
            </nav>
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className="flex md:hidden flex-col items-center w-full">
          {/* All buttons in a wrapping container */}
          <div className="flex flex-wrap justify-center gap-2 w-full">
            {/* Main Navigation Buttons */}
            <button
              onClick={() => handleNavigation('https://kingster.edu.in/', true)}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "home" ? navItemActiveClasses : ""}`}
            >
              Home
            </button>

            <button
              onClick={() => handleNavigation('https://kingster.edu.in/about-us/', true)}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "about" ? navItemActiveClasses : ""}`}
            >
              About Us
            </button>

            <button
              onClick={() => handleNavigation('/courses/Courses')}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "courses" ? navItemActiveClasses : ""}`}
            >
              Courses
            </button>

            <button
              onClick={() => handleNavigation('/webinar/webinar', true)}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "webinar" ? navItemActiveClasses : ""}`}
            >
              Webinar
            </button>

            <button
              onClick={() => handleNavigation('https://kingster.edu.in/blog/', true)}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "blogs" ? navItemActiveClasses : ""}`}
            >
              Blogs
            </button>

            <button
              onClick={() => handleNavigation('https://kingster.edu.in/contact-us/', true)}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "contact" ? navItemActiveClasses : ""}`}
            >
              Contact
            </button>

            <button
              onClick={() => handleNavigation('/affiliate/affiliate')}
              className={`inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-3 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8] ${activePage === "affiliate" ? navItemActiveClasses : ""}`}
            >
              Affiliate
            </button>

            {/* Service Buttons - with appropriate padding for longer text */}
            <button
              onClick={handleService1Click}
              className="inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-4 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8]"
            >
              Industries We Serve
            </button>

            <button
              onClick={handleService2Click}
              className="inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-4 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8]"
            >
              Ancillary Service
            </button>

            <button
              onClick={handleService3Click}
              className="inline-flex items-center justify-center whitespace-nowrap font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-center text-black no-underline h-[36px] px-4 py-2 rounded-full border border-[#DDE7EE] transition-all duration-300 hover:bg-[#1D83F8] hover:text-white hover:border-[#1D83F8]"
            >
              Ecommerce 2.0
            </button>
          </div>
        </nav>

        {/* Go to Top Button - Hidden on mobile */}
        <button className="hidden md:block">
          <a
            href="#top"
            className="inline-flex items-center justify-center gap-2 rounded-full px-2.5 py-[5px] cursor-pointer bg-[#F5F8FA] border border-[#DDE7EE] font-[Figtree] text-sm font-semibold leading-[21px] tracking-[-0.04em] text-left text-[#262626] no-underline h-[56px]"
          >
            <GotToTopIcon />
            Go To Top
          </a>
        </button>
      </div>

      {/* Footer Details Section */}
      <div className="mt-12 px-10 py-5 flex justify-between items-start flex-col md:flex-row gap-8">
        <div className="w-full">
          <p className="font-[Figtree] text-lg font-bold leading-[27px] tracking-[-0.04em] text-left text-[#262626] w-full">
            © {new Date().getFullYear()} Kingster Education. All rights reserved.
          </p>
          <div className="font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-left text-[#656567] w-full mt-2">
            You can contact us at our office located at Ashiyana 1, T.C.No. 267/1, Kelind Lane,
            Paruthipara, Muttada P. O
            Trivandrum - 695025, Kerala or reach us via phone at
            <span className='font-semibold'> 0471-2334001, 2334002, 2334003</span> or email at <span className='font-semibold'> info@kingsteredu.com</span>
          </div>
        </div>


        <div className="w-full md:text-right">
          <div className="flex items-end justify-start md:justify-end gap-2.5 mt-5">
            {/* Added Facebook icon  here - */}
            <a href="https://www.facebook.com/profile.php?id=61588660087930" target="_blank" rel="noopener noreferrer">
              <Facebook />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <Linkdin />
            </a>
            <a href="https://www.instagram.com/edubykingster/#" target="_blank" rel="noopener noreferrer">
              <Instagram />
            </a>
          </div>

          <div className="flex justify-start md:justify-end mt-2.5 gap-2.5 flex-wrap">
            <a
              href="https://kingster.edu.in/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-left md:text-right text-[#656567]"
            >
              Privacy Policy
            </a>
            <a
              href="https://kingster.edu.in/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className="font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-left md:text-right text-[#656567]"
            >
              Terms & Conditions
            </a>
            <a
              href="https://kingster.edu.in/refund-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-left md:text-right text-[#656567]"
            >
              Cancellation & Refund Policy
            </a>
            <a
              href="https://kingster.edu.in/disclaimer"
              target="_blank"
              rel="noopener noreferrer"
              className="font-[Figtree] text-sm font-medium leading-[21px] tracking-[-0.04em] text-left md:text-right text-[#656567]"
            >
              Disclaimer Policy
            </a>
          </div>
        </div>
      </div>

      <LogoIcon />
    </div>
  );
};

export default FooterComponent;